import axios from "axios"

export const addBookmark = (bookmark) => axios.post("/api/v2/account/bookmarks", bookmark)

export const deletePostBookmark = (id) => axios.delete(`/api/v2/account/bookmarks/post/${id}`)

export const deleteFolderBookmark = (id) => axios.delete(`/api/v2/account/bookmarks/folder/${id}`)

export const lastBookmarks = () =>
  axios.get("/api/v3/account/bookmarks", {
    params: {
      per_page: 3
    }
  })

export const bookmarks = ({ cursor, types }) =>
  axios.get("/api/v3/account/bookmarks", {
    params: {
      bookmarkable_type: types,
      older_than: cursor,
      per_page: 20
    }
  })

export const bookmarkedPosts = (ids) =>
  axios.get("/api/v2/posts/bookmarks", {
    params: {
      ids
    }
  })
